const arcos_list=[
    {
      "Lecturas": 2,
      "longitude": "-101.5508194",
      "latitude": "20.44433889",
      "max_severity": 1
    },
    {
      "Lecturas": 3,
      "longitude": "-101.5118389",
      "latitude": "20.46142778",
      "max_severity": 0
    },
    {
      "Lecturas": 7,
      "longitude": "-100.7300833",
      "latitude": "20.00266667",
      "max_severity": 0
    },
    {
      "Lecturas": 2,
      "longitude": "-100.696925",
      "latitude": "20.05210278",
      "max_severity": 0
    },
    {
      "Lecturas": 3,
      "longitude": "-100.7596667",
      "latitude": "20.04325",
      "max_severity": 0
    },
    {
      "Lecturas": 1,
      "longitude": "-100.6041611",
      "latitude": "20.43803889",
      "max_severity": 0
    },
    {
      "Lecturas": 12,
      "longitude": "-100.6978083",
      "latitude": "20.53887222",
      "max_severity": 0
    },
    {
      "Lecturas": 28,
      "longitude": "-100.7787111",
      "latitude": "20.51462222",
      "max_severity": 0
    },
    {
      "Lecturas": 21,
      "longitude": "-100.8086551",
      "latitude": "20.48531354",
      "max_severity": 1
    },
    {
      "Lecturas": 33,
      "longitude": "-100.8222316",
      "latitude": "20.57230717",
      "max_severity": 0
    },
    {
      "Lecturas": 67,
      "longitude": "-100.8424889",
      "latitude": "20.51903056",
      "max_severity": 0
    },
    {
      "Lecturas": 16,
      "longitude": "-100.767458",
      "latitude": "20.65185358",
      "max_severity": 3
    },
    {
      "Lecturas": 28,
      "longitude": "-100.9603",
      "latitude": "20.49376944",
      "max_severity": 1
    },
    {
      "Lecturas": 3,
      "longitude": "-100.9639771",
      "latitude": "20.45884672",
      "max_severity": 0
    },
    {
      "Lecturas": 2,
      "longitude": "-101.683739",
      "latitude": "20.66212424",
      "max_severity": 0
    },
    {
      "Lecturas": 1,
      "longitude": "-100.9433861",
      "latitude": "21.173225",
      "max_severity": 0
    },
    {
      "Lecturas": 7,
      "longitude": "-100.8905389",
      "latitude": "21.17017778",
      "max_severity": 0
    },
    {
      "Lecturas": 0,
      "longitude": "-100.9306444",
      "latitude": "21.14083611",
      "max_severity": 3
    },
    {
      "Lecturas": 2,
      "longitude": "-100.9647641",
      "latitude": "21.15888713",
      "max_severity": 1
    },
    {
      "Lecturas": 7,
      "longitude": "-101.2559152",
      "latitude": "21.03813962",
      "max_severity": 0
    },
    {
      "Lecturas": 106,
      "longitude": "-101.2839472",
      "latitude": "20.98311389",
      "max_severity": 0
    },
    {
      "Lecturas": 29,
      "longitude": "-101.3151556",
      "latitude": "20.96425",
      "max_severity": 0
    },
    {
      "Lecturas": 1,
      "longitude": "-101.5092977",
      "latitude": "20.36668723",
      "max_severity": 2
    },
    {
      "Lecturas": 1,
      "longitude": "-101.4878947",
      "latitude": "20.36330504",
      "max_severity": 0
    },
    {
      "Lecturas": 2,
      "longitude": "-101.4998537",
      "latitude": "20.35860177",
      "max_severity": 0
    },
    {
      "Lecturas": 0,
      "longitude": "-101.3721833",
      "latitude": "20.6516",
      "max_severity": 2
    },
    {
      "Lecturas": 0,
      "longitude": "-101.3463583",
      "latitude": "20.72186389",
      "max_severity": 2
    },
    {
      "Lecturas": 18,
      "longitude": "-101.3046298",
      "latitude": "20.65948552",
      "max_severity": 0
    },
    {
      "Lecturas": 0,
      "longitude": "-101.0571722",
      "latitude": "20.37611111",
      "max_severity": 2
    },
    {
      "Lecturas": 0,
      "longitude": "-101.0824182",
      "latitude": "20.37494518",
      "max_severity": 2
    },
    {
      "Lecturas": 4,
      "longitude": "-100.4998442",
      "latitude": "20.14823765",
      "max_severity": 2
    },
    {
      "Lecturas": 0,
      "longitude": "-100.5042274",
      "latitude": "20.14155854",
      "max_severity": 2
    },
    {
      "Lecturas": 1,
      "longitude": "-100.5225778",
      "latitude": "20.14429444",
      "max_severity": 0
    },
    {
      "Lecturas": 1,
      "longitude": "-100.9938397",
      "latitude": "20.62108036",
      "max_severity": 2
    },
    {
      "Lecturas": 5,
      "longitude": "-100.957068",
      "latitude": "20.62315905",
      "max_severity": 0
    },
    {
      "Lecturas": 41,
      "longitude": "-101.7347611",
      "latitude": "21.09139167",
      "max_severity": 0
    },
    {
      "Lecturas": 66,
      "longitude": "-101.7364694",
      "latitude": "21.17374167",
      "max_severity": 0
    },
    {
      "Lecturas": 3,
      "longitude": "-101.6857541",
      "latitude": "21.21196235",
      "max_severity": 1
    },
    {
      "Lecturas": 0,
      "longitude": "-101.6018472",
      "latitude": "21.07506944",
      "max_severity": 2
    },
    {
      "Lecturas": 6,
      "longitude": "-101.6970972",
      "latitude": "21.02516944",
      "max_severity": 0
    },
    {
      "Lecturas": 2,
      "longitude": "-101.9395921",
      "latitude": "20.71554068",
      "max_severity": 0
    },
    {
      "Lecturas": 10,
      "longitude": "-101.9545716",
      "latitude": "20.73912843",
      "max_severity": 0
    },
    {
      "Lecturas": 4,
      "longitude": "-101.1916445",
      "latitude": "20.08944098",
      "max_severity": 0
    },
    {
      "Lecturas": 1,
      "longitude": "-101.2172138",
      "latitude": "20.09522121",
      "max_severity": 1
    },
    {
      "Lecturas": 4,
      "longitude": "-101.4851917",
      "latitude": "21.66226944",
      "max_severity": 0
    },
    {
      "Lecturas": 20,
      "longitude": "-102.00663",
      "latitude": "20.358159",
      "max_severity": 0
    },
    {
      "Lecturas": 4,
      "longitude": "-101.707731",
      "latitude": "20.411697",
      "max_severity": 2
    },
    {
      "Lecturas": 0,
      "longitude": "-101.894525",
      "latitude": "21.016181",
      "max_severity": 2
    },
    {
      "Lecturas": 4,
      "longitude": "-101.8756222",
      "latitude": "21.05530278",
      "max_severity": 0
    },
    {
      "Lecturas": 6,
      "longitude": "-101.89515",
      "latitude": "20.98586389",
      "max_severity": 2
    },
    {
      "Lecturas": 9,
      "longitude": "-101.1697972",
      "latitude": "20.56008889",
      "max_severity": 0
    },
    {
      "Lecturas": 17,
      "longitude": "-101.2058667",
      "latitude": "20.53480278",
      "max_severity": 0
    },
    {
      "Lecturas": 20,
      "longitude": "-101.1754833",
      "latitude": "20.60473611",
      "max_severity": 0
    },
    {
      "Lecturas": 52,
      "longitude": "-101.2248361",
      "latitude": "20.58541667",
      "max_severity": 0
    },
    {
      "Lecturas": 11,
      "longitude": "-100.8990556",
      "latitude": "20.21971667",
      "max_severity": 0
    },
    {
      "Lecturas": 0,
      "longitude": "-100.89105",
      "latitude": "20.19513889",
      "max_severity": 1
    },
    {
      "Lecturas": 13,
      "longitude": "-100.8565722",
      "latitude": "20.22376111",
      "max_severity": 0
    },
    {
      "Lecturas": 3,
      "longitude": "-100.860656",
      "latitude": "21.45804299",
      "max_severity": 0
    },
    {
      "Lecturas": 3,
      "longitude": "-100.84876",
      "latitude": "21.48549165",
      "max_severity": 0
    },
    {
      "Lecturas": 3,
      "longitude": "-101.1992778",
      "latitude": "21.45291667",
      "max_severity": 0
    },
    {
      "Lecturas": 2,
      "longitude": "-101.2207778",
      "latitude": "21.46614444",
      "max_severity": 0
    },
    {
      "Lecturas": 0,
      "longitude": "-101.2517194",
      "latitude": "21.5148",
      "max_severity": 0
    },
    {
      "Lecturas": 0,
      "longitude": "-101.1425806",
      "latitude": "21.49335278",
      "max_severity": 2
    },
    {
      "Lecturas": 3,
      "longitude": "-101.8729972",
      "latitude": "21.00349444",
      "max_severity": 0
    },
    {
      "Lecturas": 2,
      "longitude": "-101.84513",
      "latitude": "20.978699",
      "max_severity": 2
    },
    {
      "Lecturas": 22,
      "longitude": "-100.4117111",
      "latitude": "20.98321944",
      "max_severity": 0
    },
    {
      "Lecturas": 4,
      "longitude": "-100.398784",
      "latitude": "21.02532051",
      "max_severity": 0
    },
    {
      "Lecturas": 4,
      "longitude": "-100.5015944",
      "latitude": "21.27936389",
      "max_severity": 0
    },
    {
      "Lecturas": 18,
      "longitude": "-100.5935566",
      "latitude": "21.2909347",
      "max_severity": 0
    },
    {
      "Lecturas": 8,
      "longitude": "-100.5590611",
      "latitude": "21.28734167",
      "max_severity": 0
    },
    {
      "Lecturas": 31,
      "longitude": "-100.757704",
      "latitude": "20.91487111",
      "max_severity": 0
    },
    {
      "Lecturas": 18,
      "longitude": "-100.7132472",
      "latitude": "20.90316111",
      "max_severity": 0
    },
    {
      "Lecturas": 13,
      "longitude": "-100.7720493",
      "latitude": "20.88151695",
      "max_severity": 2
    },
    {
      "Lecturas": 1,
      "longitude": "-100.9989694",
      "latitude": "20.18338611",
      "max_severity": 1
    },
    {
      "Lecturas": 26,
      "longitude": "-101.4378333",
      "latitude": "20.9536",
      "max_severity": 0
    },
    {
      "Lecturas": 9,
      "longitude": "-101.4621496",
      "latitude": "20.91447887",
      "max_severity": 0
    },
    {
      "Lecturas": 13,
      "longitude": "-101.422027",
      "latitude": "20.96699118",
      "max_severity": 0
    },
    {
      "Lecturas": 14,
      "longitude": "-101.4164889",
      "latitude": "20.94489444",
      "max_severity": 2
    },
    {
      "Lecturas": 3,
      "longitude": "-100.4927333",
      "latitude": "20.00421389",
      "max_severity": 0
    },
    {
      "Lecturas": 4,
      "longitude": "-100.5254611",
      "latitude": "19.98553889",
      "max_severity": 1
    },
    {
      "Lecturas": 1,
      "longitude": "-100.7488917",
      "latitude": "20.29909722",
      "max_severity": 1
    },
    {
      "Lecturas": 1,
      "longitude": "-100.7526639",
      "latitude": "20.26286111",
      "max_severity": 0
    },
    {
      "Lecturas": 0,
      "longitude": "-101.160631",
      "latitude": "20.159854",
      "max_severity": 2
    },
    {
      "Lecturas": 3,
      "longitude": "-101.164551",
      "latitude": "20.103101",
      "max_severity": 2
    },
    {
      "Lecturas": 0,
      "longitude": "-101.1557083",
      "latitude": "20.1429",
      "max_severity": 1
    },
    {
      "Lecturas": 6,
      "longitude": "-101.1902722",
      "latitude": "20.36704167",
      "max_severity": 0
    },
    {
      "Lecturas": 0,
      "longitude": "-101.154425",
      "latitude": "20.375646",
      "max_severity": 2
    },
    {
      "Lecturas": 7,
      "longitude": "-101.216472",
      "latitude": "20.393591",
      "max_severity": 0
    },
    {
      "Lecturas": 4,
      "longitude": "-101.192278",
      "latitude": "20.407472",
      "max_severity": 0
    },
    {
      "Lecturas": 9,
      "longitude": "-100.9960222",
      "latitude": "20.53041111",
      "max_severity": 0
    },
    {
      "Lecturas": 5,
      "longitude": "-101.4041263",
      "latitude": "20.09721517",
      "max_severity": 0
    },
    {
      "Lecturas": 0,
      "longitude": "-101.1498634",
      "latitude": "20.20003548",
      "max_severity": 2
    },
    {
      "Lecturas": 0,
      "longitude": "-101.513399",
      "latitude": "21.0096275",
      "max_severity": 2
    },
    {
      "Lecturas": 7,
      "longitude": "-101.435222",
      "latitude": "21.014472",
      "max_severity": 0
    },
    {
      "Lecturas": 33,
      "longitude": "-101.55625",
      "latitude": "21.08525",
      "max_severity": 0
    },
    {
      "Lecturas": 6,
      "longitude": "-101.3046389",
      "latitude": "20.6595",
      "max_severity": 0
    },
    {
      "Lecturas": 6,
      "longitude": "-101.6971111",
      "latitude": "21.02516667",
      "max_severity": 0
    },
    {
      "Lecturas": 6,
      "longitude": "-100.5593333",
      "latitude": "21.28738889",
      "max_severity": 0
    },
    {
      "Lecturas": 0,
      "longitude": "-100.9989722",
      "latitude": "20.18338889",
      "max_severity": 2
    },
    {
      "Lecturas": 0,
      "longitude": "-101.4220278",
      "latitude": "20.967",
      "max_severity": 2
    },
    {
      "Lecturas": 0,
      "longitude": "-101.4164444",
      "latitude": "20.94491667",
      "max_severity": 2
    },
    {
      "Lecturas": 5,
      "longitude": "-100.5254444",
      "latitude": "19.98552778",
      "max_severity": 0
    }
  ]

  export default arcos_list